import { useAtomValue, useSetAtom } from "jotai";
import { useMemo } from "react";

import { $personalWorkspace, $refreshWorkspaces, $workspaces } from "../../internal/workspaces";

export const useWorkspaces = () => {
	const workspaces = useAtomValue($workspaces);
	const refresh = useSetAtom($refreshWorkspaces);

	return useMemo(() => ({ ...workspaces, refresh }), [refresh, workspaces]);
};

export const usePersonalWorkspace = () => {
	return useAtomValue($personalWorkspace);
};
